export { hintStyle, errorStyle, successStyle, neutralStyle, linkStyle, sepStyle }

// Inline style fragments for the dashboard's message-line variants. Shared so colors and sizes
// stay coherent across panels + Login. Success (green) / error (red) / neutral (gray) render as
// tinted boxes — matching the free-trial form's result boxes, so the two surfaces feel like one
// product; hints stay plain text. `neutral` is the no-op outcome — a submit that
// changed nothing (e.g. "no new domains added") — gray like the free-trial form's key box.
const hintStyle = { fontSize: 13, color: '#555' } as const
// Anchor style matching vike.dev/license (docpress src/css/link.css): #4747ff, no underline.
const linkStyle = { color: '#4747ff', textDecoration: 'none' } as const
// Shared "·" separator (identity line + footer) — light gray, symmetric spacing via padding so
// both surfaces space it identically (the footer uses no flex gap; the identity line no text spaces).
const sepStyle = { color: '#ccc', padding: '0 8px' } as const
// Shared frame for the three tinted message boxes — only color + background vary per variant
// (mirrors `buttonBase` in formStyles.ts and `boxStyle` in FreeTrialForm).
const boxBase = { padding: '8px 12px', borderRadius: 6, marginTop: 12, fontSize: 13 } as const
const errorStyle = { ...boxBase, color: '#9d2222', background: '#fde2e1' } as const
const successStyle = { ...boxBase, color: '#256029', background: '#e7f7e0' } as const
// Neutral gray box — for a no-op outcome ("nothing changed", neither a win nor an error). Gray
// matches the free-trial form's key box (#eceef1) so the surfaces align.
const neutralStyle = { ...boxBase, color: '#1f2328', background: '#eceef1' } as const
